import React, { PureComponent } from 'react';
import Distance from './Distance.js';
import injectSheet from 'react-jss';
import { Scrollama, Step } from 'react-scrollama';

const styles = {
  description: {
    margin: '10px auto 30px',
    fontSize: 22,
    lineHeight: '28px',
    '& a': {
      color: 'black',
    },
  },
  graphicContainer: {
    padding: '20vh 0vw 20vh',
    display: 'flex',
    justifyContent: 'space-between',
  },
  graphic: {
    flexBasis: '60%',
    position: 'sticky',
    width: '100%',
    height: '60vh',
    top: '20vh',
    // backgroundColor: '#aaa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& p': {
      fontSize: '5rem',
      fontWeight: 700,
      textAlign: 'center',
      color: '#fff',
    },
  },
  scroller: {
    flexBasis: '38%',
    paddingRight: '2rem'
  }
}

class Tozama extends PureComponent {
  state = {
    data: 0,
    progress: 0,
    steps: [
      {
        value: 10,
        title: "江戸城からの直線距離比較",
        description: "そこで、江戸城から諸大名の居城までの直線距離を調べてみました。"
      },
      {
        value: 10,
        description: "こうして見ると、やはり江戸から遠い場所ほど外様大名の割合が高いのが見て取れます。"
      },
      {
        value: 10,
        description: "外様大名は、①徳川家康が台頭するよりも前から、先祖代々その地を治めていた者 ②織田信長や豊臣秀吉の天下統一の過程で領地を得た者 ③関ヶ原の戦いの後に転封された者など、いくつかのグループに分けられます。"
      },
      {
        value: 10,
        description: "ここからは、江戸時代の大名配置に大きな影響を与えた「関ヶ原の戦い後の論功行賞」を見ていくことにしましょう。"
      }
    ],
  }
  onStepEnter = e => {
    const { data, entry, direction } = e;
    this.setState({ data });
  }
  onStepProgress = ({ progress }) => {
    // console.log(progress)
    this.setState({ progress });
  };
  onStepExit = ({ direction, data }) => {
    if (direction === 'up' && data === this.state.steps[0]) {
      this.setState({ data: 0 });
    }
  }
  render() {
    const { data, steps, progress, zoomLevel, initialCenterPos } = this.state;
    const { classes } = this.props;

    return (
      <>
        <div className={classes.graphicContainer}>
          <div className={classes.graphic}>
            <Distance class="w-full" /> 
          </div>
          <div className={classes.scroller}>
            <Scrollama
              onStepEnter={this.onStepEnter}
              onStepExit={this.onStepExit}
              progress
              onStepProgress={this.onStepProgress}
              offset="400px"
            // debug
            >
              {steps.map(el => {
                const isVisible = el.value === data;
                const visibility = isVisible ? 'visible' : 'hidden';
                return (
                  <Step data={el.value} key={el.value}>
                    <div class="step-wrapper">
                      <div class="box" className={classes.step}>
                        {el.title && <p class="title">{el.title}</p>}
                        <p>{el.description}</p>
                      </div>
                    </div>
                  </Step>
                );
              })}
            </Scrollama>
          </div>
        </div>
      </>
    )
  }
}

export default injectSheet(styles)(Tozama);
